import './Settings.css';

// Libraries
import React, { useState, useEffect } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { Breadcrumb, ListGroup } from 'react-bootstrap';
import UsersSettings from './UsersSettings/UsersSettings';
import BlockedEmailsSettings from './BlockedEmailsSettings/BlockedEmailsSettings';
import CampaignsSettings from './CampaignsSettings/CampaignsSettings';
import ReportsSettings from './ReportsSettings/ReportsSettings';
import { ReactComponent as ArrowBackIcon } from 'assets/icons/arrow_back_icon_24.svg';
import { useTranslation } from 'react-i18next';

function Settings() {
    const { t } = useTranslation();
    let navigate = useNavigate();
    const { pathname } = useLocation();
    const [settingsPage, setSettingsPage] = useState('');

    const settingsPages = [
        { name: t('users'), path: '/settings/users' },
        { name: t('blocked_emails'), path: '/settings/blocked-emails' },
        { name: t('campaigns'), path: '/settings/campaigns' },
        { name: t('reports'), path: '/settings/reports' },
    ];

    useEffect(() => {
        setSettingsPage(settingsPages.find((sp) => sp.path === pathname));
    }, [pathname]);

    return (
        <div className="settings">
            {settingsPage ? (
                <>
                    <Breadcrumb>
                        <Breadcrumb.Item href="/settings">
                            <ArrowBackIcon height={16} width={16} className="back-btn" />
                            {t('settings')}
                        </Breadcrumb.Item>
                        {settingsPages && (
                            <Breadcrumb.Item active>{settingsPage.name}</Breadcrumb.Item>
                        )}
                    </Breadcrumb>
                    <Routes>
                        <Route path="/users" element={<UsersSettings />}></Route>
                        <Route path="/blocked-emails" element={<BlockedEmailsSettings />}></Route>
                        <Route path="/campaigns" element={<CampaignsSettings />}></Route>
                        <Route path="/reports" element={<ReportsSettings />}></Route>
                    </Routes>
                </>
            ) : (
                <>
                    <h3 className="mb-4">{t('settings')}</h3>
                    <ListGroup>
                        {settingsPages.map((page, i) => (
                            <ListGroup.Item
                                action
                                variant="light"
                                key={i}
                                onClick={() => navigate(page.path)}
                            >
                                {page.name}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </>
            )}
        </div>
    );
}

export default Settings;
